import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

let ErrorBoundary = ({ children }) => children;

// Only init if API key is available (injected via meta tag)
const apiKey = document.querySelector('meta[name="bugsnag-api-key"]')?.content;

if (apiKey) {
  Bugsnag.start({
    apiKey,
    plugins: [new BugsnagPluginReact()],
    releaseStage: document.querySelector('meta[name="bugsnag-stage"]')?.content || 'development',
    enabledReleaseStages: ['production'],
  });
  ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
}

export { ErrorBoundary };
export default Bugsnag;
